"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doPeriodsOfTheDayOverlap = exports.getOverlappingPeriodsOfTheDay = void 0;
/**
 * Time-overlap table between periods of the day.
 *
 * `allday` is the composite of morning (8h–14h) and afternoon (14h–20h); it
 * does NOT cover the night period (20h–23h), which only overlaps itself.
 */
const OVERLAPPING_PERIODS_OF_THE_DAY = {
    allday: ['allday', 'morning', 'afternoon'],
    morning: ['allday', 'morning'],
    afternoon: ['allday', 'afternoon'],
    night: ['night'],
};
/**
 * Lists the periods of the day sharing at least one hour with the given one.
 *
 * @param periodOfTheDay - the reference period
 * @returns the periods overlapping it (always includes the period itself)
 */
const getOverlappingPeriodsOfTheDay = (periodOfTheDay) => OVERLAPPING_PERIODS_OF_THE_DAY[periodOfTheDay];
exports.getOverlappingPeriodsOfTheDay = getOverlappingPeriodsOfTheDay;
/**
 * Tells whether two periods of the day share at least one hour.
 *
 * @param params.a - first period
 * @param params.b - second period
 * @returns true when the periods overlap in time
 */
const doPeriodsOfTheDayOverlap = (params) => (0, exports.getOverlappingPeriodsOfTheDay)(params.a).includes(params.b);
exports.doPeriodsOfTheDayOverlap = doPeriodsOfTheDayOverlap;
